import { api } from '../api';

const unwrap = (r) => r.data?.data ?? r.data;

export default {
  // Filters: assigneeId, status, dueFrom, dueTo, leadId, customerId,
  //          reasonCode, locationId (+ paging). `status` and `assigneeId`
  //          accept comma-separated lists.
  list:     (params)   => api.get('/v1/tasks', { params }).then(unwrap),
  create:   (body)     => api.post('/v1/tasks', body).then(unwrap),
  update:   (id, body) => api.patch(`/v1/tasks/${id}`, body).then(unwrap),
  remove:   (id)       => api.delete(`/v1/tasks/${id}`).then(unwrap),

  /**
   * A consultant's day, grouped server-side.
   * params { consultantId, date }  — date is `YYYY-MM-DD` in the org timezone.
   * → { date, timezone, overdue[], morning[], afternoon[], later[],
   *     appointments[], leadsWithoutNextEvent[], counts{} }
   */
  //
  // Served by MyDayController at /v1/my-day (a separate controller so it shipped
  // without editing LeadTaskController). The older /v1/tasks/workplan endpoint
  // still exists and returns the flat, ungrouped shape.
  workplan: (params)   => api.get('/v1/my-day', { params }).then(unwrap),

  /**
   * Complete a task and, in the same transaction, optionally book the
   * appointment it was leading to and set the following next step.
   *
   * One call on purpose: the showroom flow is "call the customer → they say
   * yes → book it", and splitting that into two requests leaves a completed
   * task and a lost booking whenever the second one fails.
   *
   * body { outcome, createAppointment?, nextTask? }
   */
  complete: (id, body) => api.post(`/v1/tasks/${id}/complete`, body).then(unwrap),

  /** Dealer-configurable reason list. params { appliesTo: 'LEAD'|'CUSTOMER' } */
  reasons:  (params)   => api.get('/v1/task-reasons', { params }).then(unwrap),
};
